export default __webpack_public_path__ + "static/media/mission.f2527817.jpg";